import { set_me } from '../../../actions/user';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import PersonalInformation from './PersonalInformation';
import GeneralForm from '../../profileInfo/components/Forms/GCForm';
import FormFieldsInfo from './FormFieldsInfo';
import { Edit, Eye } from 'lucide-react';

const PersonalInfo = ({ user, set_me, firstName, familyName, nextStep, gender }) => {
  const [isShowModal, setIsShowModal] = useState(false);

  const defaultValue = {
    firstName: firstName ?? '',
    lastName: familyName ?? '',
    gender: gender ?? '',
  };

  useEffect(() => {
    if (!user || !firstName || !familyName) {
      setIsShowModal(true);
    } else {
      setIsShowModal(false);
    }
  }, [user]);

  useEffect(() => {
    set_me();
    window.scrollTo(0, 0);
  }, []);

  const HandleClickOnEdit = () => {
    setIsShowModal(true);
  };

  const HandleClickOnView = () => {
    setIsShowModal(false);
  };

  const handleClick = (data) => {
    nextStep();
  };

  return isShowModal ? (
    <div style={{ position: 'relative', width: '100%' }}>
      {/* آیکون چشم برای بستن مودال */}
      <div
        style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          zIndex: 1000,
          cursor: 'pointer',
          borderRadius: '50%',
          padding: '8px',
          marginBottom: '10px',
        }}
        onClick={HandleClickOnView}
      >
        <Eye size={20} color='#01494b' />
      </div>
      <PersonalInformation nextStep={nextStep} />
    </div>
  ) : (
    <>
      <div
        style={{
          marginTop: '40px',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '10px',
          border: '2px solid #01494b',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* آیکون ادیت برای باز کردن مودال */}
        <div
          style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            zIndex: 100,
            cursor: 'pointer',
            borderRadius: '50%',
            padding: '8px',
            transition: 'all 0.3s ease',

            marginBottom: '10px',
          }}
          onClick={HandleClickOnEdit}
        >
          <Edit size={20} color='#01494b' />
        </div>

        <GeneralForm
          FormFieldsComponent={FormFieldsInfo}
          initialValues={defaultValue}
          submitHandler={(data) => handleClick(data)}
          buttonText='مرحله ی بعد'
          buttonLoadingText='در حال رفتن به مرحله بعد '
          buttonLoading='test'
          enableReinitialize={true}
          hasNoBorder={true}
          hasTitle={false}
          shouldBeEnd={true}
          hasSubmitButton={false}
        />
      </div>

      <div className='d-grid gap-2 mt-4' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', gap: '10px' }}>
        <button type='submit' className='confirm-button' onClick={handleClick}>
          <span className='confirm-text'>مرحله بعد</span>
        </button>
      </div>
    </>
  );
};

const MapStateToProps = (state) => ({
  firstName: state.user.name,
  familyName: state.user.family,
  mobileInfo: state.user.mobile,
  gender: state.user.gender,
  user: state.user,
  phone: state.user.phone,
  hasPassword: state.user.has_password,
});

export default connect(MapStateToProps, { set_me })(PersonalInfo);
